import React, { FC } from 'react';

const GoogleBadge: FC = () => {
  return (
    <svg viewBox="0 0 122 36">
      <defs>
        <linearGradient x1="60.376%" y1="4.959%" x2="27.932%" y2="71.805%" id="c">
          <stop stopColor="#00A0FF" offset="0%" />
          <stop stopColor="#00A1FF" offset="1%" />
          <stop stopColor="#00BEFF" offset="26%" />
          <stop stopColor="#00D2FF" offset="51%" />
          <stop stopColor="#00DFFF" offset="76%" />
          <stop stopColor="#00E3FF" offset="100%" />
        </linearGradient>
        <linearGradient x1="107.567%" y1="50%" x2="-130.487%" y2="50%" id="d">
          <stop stopColor="#FFE000" offset="0%" />
          <stop stopColor="#FFBD00" offset="41%" />
          <stop stopColor="orange" offset="78%" />
          <stop stopColor="#FF9C00" offset="100%" />
        </linearGradient>
        <linearGradient x1="86.147%" y1="29.982%" x2="-50.234%" y2="140.366%" id="e">
          <stop stopColor="#FF3A44" offset="0%" />
          <stop stopColor="#C31162" offset="100%" />
        </linearGradient>
        <linearGradient x1="-18.798%" y1="-14.959%" x2="42.093%" y2="34.362%" id="f">
          <stop stopColor="#32A071" offset="0%" />
          <stop stopColor="#2DA771" offset="7%" />
          <stop stopColor="#15CF74" offset="48%" />
          <stop stopColor="#06E775" offset="80%" />
          <stop stopColor="#00F076" offset="100%" />
        </linearGradient>
        <path id="a" d="M0 0h121.6v36H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M117.458 36H4.334C1.984 36 0 34.055 0 31.708V4.195C0 1.847 1.984 0 4.334 0h113.124c2.35 0 4.142 1.847 4.142 4.195v27.513c0 2.347-1.852 4.292-4.2 4.292h.058Z"
          fill="#B5B5B5"
          mask="url(#b)"
        />
        <path
          d="M120.916 31.709a3.452 3.452 0 0 1-3.457 3.45H4.334a3.456 3.456 0 0 1-3.46-3.45V4.194A3.46 3.46 0 0 1 4.334.74h113.124a3.456 3.456 0 0 1 3.458 3.455V31.71Z"
          fill="#000"
        />
        <path
          d="M42.397 8.618a2.378 2.378 0 0 1-.687 1.789 2.717 2.717 0 0 1-2.026.791c-1.593 0-2.884-1.253-2.884-2.799S38.091 5.6 39.684 5.6c.389 0 .774.076 1.132.226.332.13.628.335.864.597l-.487.473a1.878 1.878 0 0 0-1.51-.635c-.99.01-1.852.66-2.108 1.589-.255.93.159 1.91 1.012 2.397a2.257 2.257 0 0 0 2.651-.304 1.68 1.68 0 0 0 .462-1.086h-2.003V8.22h2.674c.02.132.03.264.026.397Zm4.803-1.53h-2.498v1.779h2.251v.666h-2.251v1.779H47.2V12H44V6.4h3.2zM49.9 12h-.6V7.087H48V6.4h3.2v.687h-1.3zm3.7 0V6.4h.8V12zm4.3 0h-.6V7.087H56V6.4h3.2v.687h-1.3zm8.5-1.61a2.87 2.87 0 0 1-3.996 0 2.858 2.858 0 0 1 0-3.975 2.844 2.844 0 0 1 1.997-.815c.749 0 1.467.293 1.996.815a2.858 2.858 0 0 1 0 3.972l.003.003Zm-3.479-.448a2.122 2.122 0 0 0 2.96 0c.81-.872.81-2.207 0-3.08a2.121 2.121 0 0 0-2.96 0 2.264 2.264 0 0 0 0 3.08ZM68 12V6.4h.812l2.521 4.355h.031l-.031-1.079V6.4H72V12h-.695l-2.638-4.568h-.027l.027 1.079V12z"
          stroke="#FFF"
          strokeWidth=".5"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M61.283 19.4c-2.138 0-3.87 1.705-3.87 3.81s1.732 3.81 3.87 3.81c2.137 0 3.87-1.705 3.87-3.81a3.714 3.714 0 0 0-1.113-2.715 3.834 3.834 0 0 0-2.757-1.096Zm0 6.1a2.347 2.347 0 0 1-2.277-1.306 2.279 2.279 0 0 1 .399-2.565 2.367 2.367 0 0 1 2.57-.575 2.306 2.306 0 0 1 1.485 2.143 2.178 2.178 0 0 1-.596 1.603c-.41.434-.98.686-1.581.7Zm-8.447-6.1c-2.138 0-3.87 1.705-3.87 3.81s1.732 3.81 3.87 3.81 3.87-1.705 3.87-3.81a3.714 3.714 0 0 0-1.113-2.715 3.834 3.834 0 0 0-2.757-1.096Zm0 6.1a2.347 2.347 0 0 1-2.277-1.306 2.279 2.279 0 0 1 .399-2.565 2.367 2.367 0 0 1 2.57-.575 2.306 2.306 0 0 1 1.485 2.143 2.178 2.178 0 0 1-.596 1.603c-.41.434-.98.686-1.581.7Zm-10.047-4.935v1.613h3.916a3.329 3.329 0 0 1-.89 2.026 4.042 4.042 0 0 1-3.026 1.181c-2.404 0-4.354-1.92-4.354-4.287 0-2.368 1.95-4.287 4.354-4.287 1.1-.014 2.16.4 2.951 1.153l1.155-1.137A5.753 5.753 0 0 0 42.79 15.2c-3.307 0-5.989 2.64-5.989 5.897s2.682 5.898 5.99 5.898c1.783 0 3.128-.575 4.192-1.655s1.416-2.56 1.416-3.77a5.234 5.234 0 0 0-.087-1.006H42.79Zm41.087 1.25c-.323-.847-1.29-2.416-3.3-2.416-2.009 0-3.638 1.54-3.638 3.811a3.685 3.685 0 0 0 1.09 2.709 3.804 3.804 0 0 0 2.739 1.102 3.845 3.845 0 0 0 3.225-1.683l-1.316-.864a2.204 2.204 0 0 1-1.896 1.051 1.96 1.96 0 0 1-1.871-1.15l5.16-2.102-.193-.457Zm-5.257 1.271a2.06 2.06 0 0 1 .531-1.53c.38-.419.915-.669 1.485-.693a1.5 1.5 0 0 1 1.432.804l-3.448 1.42Zm-4.193 3.684h1.693V15.614h-1.693V26.77Zm-2.777-6.517h-.058a2.687 2.687 0 0 0-2.032-.85c-1.935 0-3.696 1.67-3.696 3.81-.013 2.04 1.626 3.717 3.696 3.783a2.648 2.648 0 0 0 2.032-.864h.058v.55c0 1.45-.79 2.222-2.061 2.222a2.13 2.13 0 0 1-1.935-1.353l-1.477.604a3.681 3.681 0 0 0 3.418 2.245c1.987 0 3.668-1.153 3.668-3.957V19.63h-1.613v.622Zm-1.935 5.25c-1.171 0-2.148-.953-2.148-2.287 0-1.333.967-2.315 2.148-2.315 1.18 0 2.058.978 2.058 2.315s-.913 2.284-2.065 2.284l.007.003Zm22.103-9.89h-4.058v11.163h1.693v-4.24h2.365c1.873 0 3.718-1.336 3.718-3.467 0-2.131-1.845-3.455-3.718-3.455Zm.041 5.38h-2.406v-3.836h2.406c1.074 0 1.944.857 1.944 1.913 0 1.057-.87 1.914-1.944 1.914v.01Zm10.454-1.613c-1.223 0-2.494.53-3.02 1.709l1.504.619a1.62 1.62 0 0 1 1.548-.82c.874 0 1.764.518 1.777 1.436v.114a3.798 3.798 0 0 0-1.764-.428c-1.613 0-3.267.873-3.267 2.512 0 1.492 1.328 2.454 2.815 2.454a2.398 2.398 0 0 0 2.158-1.089h.058v.86h1.635v-4.28c.003-1.982-1.51-3.087-3.444-3.087Zm-.204 6.117c-.554 0-1.325-.27-1.325-.953 0-.86.967-1.191 1.793-1.191a3.037 3.037 0 0 1 1.545.371 2.037 2.037 0 0 1-2.01 1.773h-.003Zm9.599-5.872-1.935 4.84h-.058l-2.013-4.84h-1.822l3.019 6.764-1.723 3.763h1.764l4.661-10.527h-1.893Zm-15.243 7.142h1.693V15.614h-1.693v11.153Z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M10.004 6.476c-.282.35-.425.799-.4 1.254v19.734c-.03.46.113.915.4 1.27l.065.066L20.8 17.743v-.26L10.07 6.4l-.066.076Z"
          fill="url(#c)"
          fillRule="nonzero"
        />
        <path
          d="M23.9 21.6 20 18.123v-.246l3.9-3.477.087.045 4.623 2.343c1.32.672 1.32 1.767 0 2.436l-4.623 2.346-.087.03Z"
          fill="url(#d)"
          fillRule="nonzero"
        />
        <path
          d="M23.984 21.546 20.138 17.6 8.8 29.226c.421.459 1.114.515 1.895.06L24 21.533"
          fill="url(#e)"
          fillRule="nonzero"
        />
        <path
          d="M24 14.47 10.695 6.713c-.78-.455-1.474-.398-1.895.057L20.155 18.4 24 14.47Z"
          fill="url(#f)"
          fillRule="nonzero"
        />
        <path
          d="m23.916 21.6-13.22 7.566c-.743.421-1.404.395-1.828 0l-.068.069.068.065c.424.385 1.085.414 1.827 0L24 21.685l-.084-.085Z"
          fill="#000"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M9.49 28.723c-.485-.202-.73-.46-.685-.723v.077c-.043.262.202.52.684.723l.111-.038-.11-.039Zm19.116-9.904L24 21.512l.086.088 4.527-2.633c.658-.374.987-.872.987-1.367a1.761 1.761 0 0 1-.994 1.219Z"
          fill="#000"
          fillRule="nonzero"
          opacity=".12"
        />
        <path
          d="m11.089 6.85 17.55 10.339c.487.224.843.673.961 1.211 0-.488-.32-.976-.96-1.348L11.089 6.714C9.83 5.974 8.8 6.588 8.8 8.08v.136c0-1.493 1.03-2.097 2.289-1.367Z"
          fill="#FFF"
          fillRule="nonzero"
          opacity=".25"
        />
      </g>
    </svg>
  );
};

export default GoogleBadge;
